<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row justify="center" class="mt-50">
            <v-col cols="12" md="12" lg="8">
                <v-container>
                    <h2>{{$t('errors.title')}} {{$t('errors.404.title')}}</h2>
                    <span>{{$t('errors.404.content')}}</span>
                </v-container>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
// import { ref, getCurrentInstance } from "vue";
// import { useRouter } from 'vue-router'

export default {
    data() {
        return {
        }
    },
    setup() {
    

        return {
        };
    },
};
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    width: 1170px;
}
</style>